import { Component, Input, OnInit } from '@angular/core';
import { uuid4 } from '@sentry/utils';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { AppInviteRequest } from 'src/lib/fliko/models/http/appInviteRequest.data';
import { MsgStatus } from 'src/lib/fliko/models/integrations/sendDataBase.data';
import { SMSType } from 'src/lib/fliko/models/integrations/sendSMS.data';
import { SMSQueueData } from 'src/lib/fliko/models/messageQueue/sms.data';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { AppInviteService } from 'src/app/view/users/services/appInvite.service';
import { ErrorHandlingService } from '../../error-handling/error-handling.service';
import { AppInviteTemplate } from '../../models/appInvite.view-model';
import { DialogService } from '../../services/dialog.service';
import { LocalizationService } from '../../services/localization.service';
import { SendSMSService } from '../../services/send-sms.service';
import { TemplateService } from '../../services/template-service/template.service';

@Component({
  selector: 'app-app-invitation',
  templateUrl: './app-invitation.component.html',
  styleUrls: ['./app-invitation.component.scss']
})
export class AppInvitationComponent implements OnInit {
  @Input() inviteSent = false;
  @Input() invitedNumber = false;

  @Input() invTemplate!: AppInviteTemplate;

  public isSubmitting = false;

  private invRequest!: AppInviteRequest;
  private estateId: string = '';
  private acApp: boolean = false;
  private trans = (x: string) => this.ls.translate(x);

  constructor(
    public rwdService: RWDService,
    public templateService: TemplateService,
    private dialogService: DialogService,
    private errorHandlingService: ErrorHandlingService,
    private ctxDS: ContextDataService,
    private inviteService: AppInviteService,
    private ls: LocalizationService,
    private smsService: SendSMSService
  ) {}

  ngOnInit(): void {
    const estate = this.ctxDS.peekCurrentEstate();
    this.estateId = estate?.id ?? '';
    this.acApp = estate?.acApp ?? false;
    this.invRequest = {
      estateId: this.estateId,
      queueRefId: '',
      receivers: [{ id: this.invTemplate.receiverId, phoneNumber: this.invTemplate.phoneNumber }]
    };
  }

  public sendAppInvite(): void {
    const $type = this.trans('appInvite.user');
    const $user = ToString.fullName(this.invTemplate);
    const $number = this.invTemplate.phoneNumber;
    this.dialogService
      .openConfirmationDialog({
        text: this.ls.trReplace('guard.appInvite', { $type, $user, $number }),
        acceptKey: 'button.send',
        cancelKey: 'button.cancel'
      })
      .subscribe(async (result) => {
        if (result) {
          try {
            const queueObj: SMSQueueData = {
              id: `${this.estateId}_${uuid4()}`,
              creatorId: this.ctxDS.peekCurrentUser()?.id ?? '',
              createDate: Date.now(),
              estateId: this.estateId,
              receiver: { id: this.invTemplate.receiverId, phone: this.invTemplate.phoneNumber },
              receivers: null,
              status: MsgStatus.PENDING,
              sendDate: Date.now(),
              type: this.acApp ? SMSType.APP_INVITE_ACA : SMSType.APP_INVITE,
              refId: null
            };
            this.isSubmitting = true;
            await this.smsService.sendSMS(queueObj);
            const result = await this.inviteService.requestAppInviteUpdate({ ...this.invRequest, queueRefId: queueObj.id });
            if (!result) this.errorHandlingService.showGlobalError(this.trans('error.invitation'));
          } catch (e) {
            this.errorHandlingService.showGlobalError(this.trans('error.invitation'), e);
          } finally {
            this.isSubmitting = false;
          }
        }
      });
  }
}
